import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Quill from "quill";

import "./index.css";

function CommentWidgetContent(props) {
  const { pathname } = useLocation();
  const [quill, setQuill] = useState({});
  const [textContent, setTextContent] = useState();
  const id = `${props.lesson_module_name}${props.id || props.position}`
  useEffect(() => {
    const q = new Quill(`#${id}`, {
      modules: { toolbar: true },
      theme: 'snow',
    });
    setQuill(q);
    setTextContent(props.text_content);
    if (props.text_content && props.text_content.length > 0) {
      q.setContents(JSON.parse(props.text_content));
    } else {
      q.setContents({ insert: "" })
    }
    q.on("text-change", (e) => {
      const { ops } = q.getContents();
      setTextContent(JSON.stringify(ops));
    })
  }, []);

  // sets comment widget contents when navigating
  useEffect(() => {
    if (
      quill.setContents &&
      (props.text_content && props.text_content.length > 0)
    ) {
      quill.setContents(JSON.parse(props.text_content));
    } else if (quill.setContents) {
      quill.setContents(null);
    }
  }, [pathname, props.text_content])

  useEffect(updateWidgets, [textContent])

  function updateWidgets() {
    if (textContent) {
      props.onSetWidgets("text_content", textContent);
    }
  }

  return (
    <div className="CommentWidgetContent">
      <div id={id} />
    </div>
  )
}

export default CommentWidgetContent;
